import { useState } from 'react';
import { FiX } from 'react-icons/fi';

// Chip-style tag entry. Enter or comma commits a tag.
export default function TagInput({ value = [], onChange, placeholder = 'Type and press Enter' }) {
  const [input, setInput] = useState('');

  const add = (raw) => {
    const t = raw.trim().replace(/,$/, '');
    if (t && !value.includes(t)) onChange([...value, t]);
    setInput('');
  };

  const onKey = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      add(input);
    } else if (e.key === 'Backspace' && !input && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div className="input" style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', minHeight: 48, height: 'auto' }}>
      {value.map((t) => (
        <span key={t} className="tag-chip" style={{ color: 'var(--text)' }}>
          #{t}
          <FiX style={{ cursor: 'pointer' }} onClick={() => onChange(value.filter((x) => x !== t))} />
        </span>
      ))}
      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={onKey}
        onBlur={() => input && add(input)}
        placeholder={value.length ? '' : placeholder}
        style={{ flex: 1, minWidth: 120, background: 'none', border: 'none', outline: 'none', color: 'var(--text)', fontSize: 15 }}
      />
    </div>
  );
}
